import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === '/';

  const goToSection = (id: string) => {
    setMobileOpen(false);
    if (isHome) {
      const el = document.getElementById(id);
      el?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: id } });
    }
  };

  const goHome = () => {
    setMobileOpen(false);
    if (isHome) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center flex-shrink-0">
            <img
              alt="Editora LT Logo"
              className="h-16 object-contain"
              src="https://public.readdy.ai/ai/img_res/30ad6aa5-9596-4064-90bd-9dc3fd772e74.png"
            />
          </a>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-2">
            {/* Povos do Brasil — destaque */}
            <button
              onClick={goHome}
              className="flex items-center gap-2 px-4 py-2 rounded-full text-sm font-bold text-white transition-all whitespace-nowrap cursor-pointer hover:opacity-90"
              style={{ background: 'linear-gradient(135deg, #C85C2A, #E8A42A)' }}
            >
              <div className="flex gap-1">
                <div className="w-1.5 h-1.5 rounded-full bg-white/80"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-white/50"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-white/80"></div>
              </div>
              Povos do Brasil
            </button>

            <button
              onClick={() => goToSection('sobre-section')}
              className="text-sm font-medium text-gray-600 hover:text-[#C85C2A] px-4 py-2 rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              Sobre
            </button>

            <button
              onClick={() => goToSection('contato-section')}
              className="ml-2 px-6 py-2.5 rounded-full text-sm font-semibold bg-gray-900 text-white hover:bg-[#C85C2A] transition-colors whitespace-nowrap cursor-pointer"
            >
              Contato
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-3">
            <button
              onClick={goHome}
              className="flex items-center gap-2 text-sm font-bold text-white px-4 py-3 rounded-xl cursor-pointer whitespace-nowrap hover:opacity-90 transition-opacity"
              style={{ background: 'linear-gradient(135deg, #C85C2A, #E8A42A)' }}
            >
              <div className="flex gap-1">
                <div className="w-1.5 h-1.5 rounded-full bg-white/80"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-white/50"></div>
                <div className="w-1.5 h-1.5 rounded-full bg-white/80"></div>
              </div>
              Povos do Brasil
            </button>

            <button
              onClick={() => goToSection('sobre-section')}
              className="text-sm font-medium text-gray-700 hover:text-[#C85C2A] py-2 text-left cursor-pointer whitespace-nowrap transition-colors"
            >
              Sobre
            </button>

            <button
              onClick={() => goToSection('contato-section')}
              className="bg-gray-900 text-white px-6 py-3 rounded-xl text-sm font-semibold cursor-pointer whitespace-nowrap hover:bg-[#C85C2A] transition-colors"
            >
              Contato
            </button>
          </div>
        )}
      </nav>
    </>
  );
}
